import { Component, Input, OnInit } from '@angular/core';
import { Platform, PopoverController } from '@ionic/angular';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  templateUrl: 'loyalty.html',
  styleUrls: ['./loyalty.component.scss'],
})

export class LoyaltyPopover implements OnInit {
  @Input() data: any;
  public isAndroidOrMobileWeb: boolean;
  rewardCardIcon =""

  constructor(
    private popoverController: PopoverController,
    private platform: Platform,
    public utils: UtilsService) {}

  ngOnInit(){
    this.isAndroidOrMobileWeb = this.platform.is("android") || this.platform.is("mobileweb");
    this.setRewardsIcon()
  }

  private setRewardsIcon() {
    const level = this.data?.message?.parametersMap?.order || 1;
    const imgName = `rewards_${level}.png`;
    this.rewardCardIcon = this.utils.getCDNAsset(`rewardcards/${imgName}`);
  }
    
  closePopover = () => {
    return this.popoverController.dismiss();   
  }
}